module.exports = __webpack_public_path__ + "assets/static/png/mypayments-grey.f825de2a0614980e088e361b5a90100a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/myPayments/images/mypayments-grey.png
 ** module id = 511
 ** module chunks = 1
 **/